import { Route, Routes } from "react-router-dom";
import { Dashboard } from "./pages/Dashboard";
import { DashboardLayout } from "./layouts/DefaultLayout";
import { LoginPage } from "./pages/Login-page";
import { RegisterAccount } from "./pages/Register-Account";
import { RegisterCompany } from "./pages/Register-Company";
import { RegisterBuilding } from "./pages/Register-Buildings";
import { RegisterExpense } from "./pages/Register-Expenses";
import { RegisterInvoice } from "./pages/Register-Invoices";
import { CreateInvoice } from "./pages/Create-Invoice";
import { RegisterService } from "./pages/Register-Services";

export function Router() {
  return (
    <Routes>
      <Route path="/" element={<DashboardLayout />}>
        {" "}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/buildings" element={<RegisterBuilding />} />
        <Route path="/expenses" element={<RegisterExpense />} />
        <Route path="/invoices" element={<RegisterInvoice />} />
        <Route path="/invoices/create" element={<CreateInvoice />} />
        <Route path="/services" element={<RegisterService />} />
      </Route>
      <Route path="/" element={<LoginPage />} />
      <Route path="/users" element={<RegisterAccount />} />
      <Route path="/company" element={<RegisterCompany />} />
    </Routes>
  );
}
